class MmScrollBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.stbStickyEle = this.querySelector('.mm-scroll-bar__bar');
    this.stbListEle = this.querySelector('.mm-scroll-bar__list');
    this.listWidth = this.stbListEle ? this.stbListEle.scrollWidth : 0;
    this.scrollToShow = this.classList.contains('scroll-to-show') && !(window.Shopify && Shopify.designMode);
    if (!this.scrollToShow) {
      this.classList.remove('scroll-to-show');
      this.removeAttribute('aria-hidden');
    }

    this.onScroll = this.onScroll.bind(this);
    this.updateStickyTop = this.updateStickyTop.bind(this);
    this.onDOMContentLoaded = this.onDOMContentLoaded.bind(this);

    this.updateStickyTop();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', this.onDOMContentLoaded);
    } else {
      this.onDOMContentLoaded();
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    window.removeEventListener('DOMContentLoaded', this.onDOMContentLoaded);
  }

  onDOMContentLoaded() {
    this.init();

    let stbFirstItem = this.querySelector('.mm-scroll-bar__list .mm-scroll-bar__item');
    if (stbFirstItem && !stbFirstItem.classList.contains('is-selected')) {
      stbFirstItem.classList.add('is-selected');
    }
  }

  init() {
    this.updateStickyTop();
    this.stickyBar();
    this.setupButtons();
    this.initScrollToSection();
    if (this.stbListEle && this.listWidth > this.stbListEle.clientWidth) {
      this.stbListEle.classList.add('is-overflow');
    }
  }

  updateStickyTop() {
    this.announceBarHeight = document.querySelector('.announcement-bar-section')?.clientHeight || 0;
    this.headerHeight = document.querySelector('.section-header')?.clientHeight || 0;
    const top = this.announceBarHeight + this.headerHeight;
    if (this.stickyTop !== top) {
      this.stickyTop = top;
      this.style.setProperty('--top', `${top}px`);
    }
    this.syncBarHeight();
  }

  syncBarHeight() {
    const barVisible = !this.scrollToShow || this.classList.contains('is-fixed');
    this.barHeight = barVisible ? (this.stbStickyEle?.offsetHeight || 0) : 0;
    this.headerBarTotalHeight = this.announceBarHeight + this.headerHeight + this.barHeight;
    if (this.scrollToShow) {
      if (barVisible) this.removeAttribute('aria-hidden');
      else this.setAttribute('aria-hidden', 'true');
    }
  }

  setSelected(item) {
    if (!item || item.classList.contains('is-selected')) return;
    const fromElement = this.querySelector('.mm-scroll-bar__item.is-selected');
    this.querySelectorAll('.mm-scroll-bar__item.is-selected').forEach((el) => el.classList.remove('is-selected'));
    item.classList.add('is-selected');
    requestAnimationFrame(() => this.scrollToSelectedItem(item, fromElement));
  }

  scrollToSelectedItem(element, fromElement) {
    if (!element || !this.stbListEle || !this.stbListEle.classList.contains('is-overflow')) return;

    let items = Array.from(this.stbListEle.querySelectorAll('.mm-scroll-bar__item'));
    let toIndex = items.indexOf(element);
    let fromIndex = items.indexOf(fromElement);
    let alignEl = element;

    if (fromIndex !== -1 && toIndex < fromIndex) {
      alignEl = items[toIndex - 1] || null;
    }

    let left = 0;
    if (alignEl) {
      left = alignEl.getBoundingClientRect().left - this.stbListEle.getBoundingClientRect().left + this.stbListEle.scrollLeft;
    }
    this.stbListEle.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
  }

  changeSelected() {
    if (this.lockSelected) return;
    let scrollTop = $(window).scrollTop() || document.documentElement.scrollTop;
    let currentItem = null;
    document.querySelectorAll('.section').forEach((section) => {
      let tempDivId = section.getAttribute('id');
      if (!tempDivId) return;
      let item = this.querySelector(`.mm-scroll-bar__item[data-target-id='${tempDivId}']`);
      if (item && scrollTop >= section.offsetTop - this.headerBarTotalHeight) {
        currentItem = item;
      }
    });
    if (currentItem) this.setSelected(currentItem);
  }

  stickyBar() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const divOffsetTop = this.offsetTop - this.announceBarHeight - this.headerHeight;
    this.classList.toggle('is-fixed', scrollTop >= divOffsetTop);
    this.syncBarHeight();
  }

  onScroll() {
    this.updateStickyTop();
    this.stickyBar();
    this.changeSelected();
  }

  setupButtons() {
    let stbButtons = this.querySelectorAll('.mm-scroll-bar__item');
    stbButtons.forEach((el) => {
      let targetId = el.getAttribute('data-target-id');
      if (!document.getElementById(targetId)) {
        el.remove();
      } else {
        document.getElementById(targetId)?.setAttribute('tabindex', '-1');
        el.addEventListener('click', this.onButtonClick.bind(this, targetId));
        el.addEventListener('keydown', function (e) {
          if (e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            e.target.click();
          }
        });
      }
    });
  }

  onButtonClick(targetId, event) {
    event.preventDefault();
    let tab = this.querySelector(`.mm-scroll-bar__item[data-target-id="${targetId}"]`);
    this.setSelected(tab);
    this.lockSelected = true;
    const unlock = () => {
      this.lockSelected = false;
      window.removeEventListener('scrollend', unlock);
    };
    window.addEventListener('scrollend', unlock, { once: true });
    setTimeout(unlock, 800);
    let element = document.getElementById(targetId);
    history.pushState(null, null, `#${targetId}`);
    if (element) {
      element.focus();
      let elementPosition = element.getBoundingClientRect().top;
      let offsetPosition = elementPosition + ($(window).scrollTop() || document.documentElement.scrollTop) - this.headerBarTotalHeight + 10;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  }

  initScrollToSection() {
    let element = window.location.hash ? document.querySelector(window.location.hash) : null;
    if (element) {
      element.focus();
      let elementPosition = element.getBoundingClientRect().top;
      let offsetPosition = elementPosition + ($(window).scrollTop() || document.documentElement.scrollTop) - this.headerBarTotalHeight + 10;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  }
}

customElements.define('mm-scroll-bar', MmScrollBar);
